"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CouponType;
(function (CouponType) {
    CouponType[CouponType["DISCOUNT"] = 0] = "DISCOUNT";
    CouponType[CouponType["DEDUCTION"] = 1] = "DEDUCTION";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
var CouponStatus;
(function (CouponStatus) {
    CouponStatus[CouponStatus["UNUSED"] = 0] = "UNUSED";
    CouponStatus[CouponStatus["USED"] = 1] = "USED";
})(CouponStatus = exports.CouponStatus || (exports.CouponStatus = {}));
//# sourceMappingURL=coupon.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/coupon.js
// module id = 996
// module chunks = 0